import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IBrandingStyleRequest, IBrandingStyleResponse } from './branding-model';

@Injectable()
export class BrandingService {
    constructor(
        private http: HttpClient
    ) { }

    private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}`; }
    private static readonly ENDPOINT = 'brandings';

    /** GET */
    public getBrandingSettings(): Observable<SuccessResponse<IBrandingStyleResponse> | ErrorResponse>  {
        return this.http
            .get<SuccessResponse<IBrandingStyleResponse>>(
                BrandingService.URL +
                BrandingService.ENDPOINT
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

    /** POST */
    public addBrandingSettings(brandingSettings: IBrandingStyleRequest): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(
                BrandingService.URL +
                BrandingService.ENDPOINT,
                brandingSettings
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }


    /** PUT */
    public updateBrandingSettings(brandingSettings: IBrandingStyleRequest): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(
                BrandingService.URL +
                BrandingService.ENDPOINT,
                brandingSettings
            ).pipe(
            catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
    }

}
